<script setup>
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import adminJobfairStateService from "../../../services/jobfair/adminJobfairStateService";
import MemberJobFairInterestedCorpJobNoticeListView from "./MemberJobFairInterestedCorpJobNoticeListView.vue";

const { $pageListBoardNo, $toast, $number, $gbNameKR, $yyyymmddHHmmss, alert, confirm } = getCurrentInstance().appContext.config.globalProperties;

const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore();

const props = defineProps({
  userId: {
    type: [String, Number],
    required: true,
  }
});

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);
const list = ref([]);

const isJobNoticeListView = ref(false);
const selectedCorpId = ref('');

const pageSizeGroup = ref([
  { label:"10개씩 보기", value: 10 },
  { label:"30개씩 보기", value: 30 },
  { label:"50개씩 보기", value: 50 },
  { label:"100개씩 보기", value: 100 },
])

const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

// 페이지당 개수 변경
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveList();
}

const retrieveList = () => {
  let paramObj = {
    userId: props.userId,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  adminJobfairStateService.retrieveInterestHallEntryCorpListPagingByUserId(paramObj)
    .then( async (res) => {
      loadingStore.loading = false;
      if (res.data.code.toLowerCase() === "success") {
        const result = res.data.result;
        totalPages.value = result.totalPages;
        totalCount.value = result.totalElements;
        list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
      }
    })
    .catch((res) => {
      loadingStore.loading = false;
      $toast("error", res);
    });
};

// 채용 수 클릭
const onClickJobNoticeCnt = (corpId) => {
  isJobNoticeListView.value = true;
  selectedCorpId.value = corpId;
}

const openDetailInNewTab = (linkName, id, query = {}) => {
  const url = router.resolve({
    name: linkName,
    params: { id },
    query,
  }).href;

  window.open(url, '_blank');
}

onMounted(()=>{
  retrieveList();
});
</script>

<template>
  <div v-if="!isJobNoticeListView">
    <!-- s: 버튼영역 -->
    <div class="list-top">
      <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
    <!-- e: 버튼영역 -->
    <div class="table-form">
      <table class="horizontal" v-if="list !== null">
        <tr>
          <th>NO</th>
          <th>기업명</th>
          <th>마스터</th>
          <th>기업형태</th>
          <th>산업군</th>
          <th>업종</th>
          <th>채용공고</th>
          <th>관심 등록일</th>
        </tr>
        <tr v-for="corp in list">
          <td>{{ corp.boardNo }}</td>
          <td class="clickable blue text-overflow long-overflow">
            <span @click="openDetailInNewTab('CorporationDetail', corp.corpId, { tab: 3, tab2: 'job-postings' })">{{ corp.corpName }}</span>
          </td>
          <td class="clickable blue">
            <span @click="openDetailInNewTab('MemberDetail', corp.userId)">{{ corp.userName }}</span>
          </td>
          <td>{{ $gbNameKR('CORP_GB', corp.corpGb)}}</td>
          <td>{{ $gbNameKR('INDUSTRY_GB', corp.industryGb) }}</td>
          <td class="text-overflow long-overflow">{{ corp.bizType }}</td>
          <td class="clickable blue" @click="onClickJobNoticeCnt(corp.corpId)">{{ corp.jobNoticeCnt }}</td>
          <td>{{ $yyyymmddHHmmss(corp.modifyDate) }}</td>
        </tr>
      </table>
      <div class="result-none" v-if="list.length === 0">
        등록된 관심 기업이 없습니다.
      </div>
    </div>
    <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
    />
  </div>
  <div v-if="isJobNoticeListView">
    <MemberJobFairInterestedCorpJobNoticeListView
      :corpId="selectedCorpId"
      :userId="props.userId"
      @go-back="isJobNoticeListView = false"
    />
  </div>
</template>

<style scoped>
</style>